import { render, staticRenderFns } from "./_base-title-report-menu.vue?vue&type=template&id=4a1fc742&scoped=true"
import script from "./_base-title-report-menu.vue?vue&type=script&lang=js"
export * from "./_base-title-report-menu.vue?vue&type=script&lang=js"
import style0 from "./_base-title-report-menu.vue?vue&type=style&index=0&id=4a1fc742&prod&lang=scss&scoped=true"
import style1 from "./_base-title-report-menu.vue?vue&type=style&index=1&id=4a1fc742&prod&lang=scss&module=true"




function injectStyles (context) {
  
  this["$style"] = (style1.locals || style1)

}

/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  injectStyles,
  "4a1fc742",
  null
  
)

export default component.exports